<template>
  <div
    class="mobile-modal"
    :class="{'mobile-modal_active': isActive || alwaysOpen}"
  >
    <div class="mobile-modal__header">
      <div class="mobile-modal__header-grid grid grid_gutters-sm grid_v-center">
        <div class="grid__col grid__col_auto">
          <button
            class="mobile-modal__close button button_square"
            type="button"
            @click="cancel"
          >
            <span class="button__icon">
              <icon icon-name="close" v-if="!backIcon"></icon>
              <icon icon-name="left" v-else></icon>
            </span>
          </button>
        </div>
        <div class="mobile-modal__name grid__col grid__col_stretch">
          <b class="mobile-modal__name-text" v-html="name"></b>
          <template v-if="count">
            &nbsp;&nbsp;
            <badge
              class="badge_circle"
              :text="count"
              type="danger"
              size="sm"
            ></badge>
          </template>
        </div>
        <div
          class="grid__col grid__col_auto"
          v-if="showResetBtn"
        >
          <button
            class="button button_sm button_secondary"
            type="button"
            @click="$emit('reset')"
          >
            <span class="button__text">Очистить</span>
          </button>
        </div>
      </div>
    </div>
    <div class="mobile-modal__body">
      <slot></slot>
    </div>
    <div class="mobile-modal__footer" v-show="!hideFooter">
      <button
        class="button button_primary button_wide"
        type="button"
        @click="apply"
      >
        <span class="button__text">{{ applyText }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Badge from '@/components/Badge.vue'

export default {
  name: 'MobileModal',
  components: {
    Badge
  },
  props: {
    name: String,
    count: [String, Number],
    backIcon: Boolean,
    alwaysOpen: Boolean,
    applyText: {
      type: String,
      default: 'Применить'
    },
    showResetBtn: Boolean,
    hideFooter: Boolean
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    open () {
      this.isActive = true
      setTimeout(() => {
        this.$el.scrollTo(0, 0)
      })
      this.$emit('open')
    },
    close () {
      this.$emit('close')
      this.isActive = false
    },
    cancel () {
      this.close()
      this.$emit('cancel')
    },
    apply () {
      this.$emit('apply')
      this.close()
    }
  }
}
</script>

<style lang="scss">
  .mobile-modal {
    display: none;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $color-white;
    overflow-x: hidden;
    padding-top: 56px;
    padding-bottom: 64px;

    &_active {
      display: block;
    }

    &__header {
      position: fixed;
      z-index: 10;
      top: 0;
      left: 0;
      width: 100%;
      background-color: $color-white;
      box-shadow: $elevation-deth-4;
    }

    &__header-grid {
      flex-wrap: nowrap;
      height: 56px;
      padding: 0 16px;
    }

    &__close {
      margin-left: -10px;

      &::after {
        content: none;
      }
    }

    &__name {
      display: flex;
      align-items: center;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__name-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 0 1 auto;
    }

    &__body {
      padding: 16px;
    }

    &__body-item {
      margin-top: 16px;

      &:first-child {
        margin-top: 0;
      }
    }

    &__full {
      margin-left: -16px;
      margin-right: -16px;
    }

    &__footer {
      display: flex;
      align-items: center;
      padding: 0 16px;
      height: 64px;
      position: fixed;
      z-index: 10;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: $color-white;
      border-top: 1px solid map_get($color-neutral-black, 9);
    }
  }
</style>
